import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../../atoms/button/button.component';
import { TextareaFieldComponent } from '../../atoms/forms/textarea-field/textarea-field.component';

export interface ConfirmDialogWithReasonData {
  title: string;
  message: string;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  confirmText?: string;
  cancelText?: string;
}

export interface ConfirmDialogWithReasonResult {
  confirmed: boolean;
  reason: string;
}

@Component({
  selector: 'htx-confirm-dialog-with-reason',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent, TextareaFieldComponent],
  templateUrl: './confirm-dialog-with-reason.component.html',
  styleUrl: './confirm-dialog-with-reason.component.scss'
})
export class ConfirmDialogWithReasonComponent {
  data = input<ConfirmDialogWithReasonData | null>(null);
  confirmed = output<ConfirmDialogWithReasonResult>();

  reasonControl = new FormControl('', Validators.required);

  confirm(): void {
    this.reasonControl.markAsTouched();
    if (this.reasonControl.invalid) return;

    this.confirmed.emit({
      confirmed: true,
      reason: this.reasonControl.value?.trim() || ''
    });
    this.reasonControl.reset();
  }

  cancel(): void {
    this.confirmed.emit({ confirmed: false, reason: '' });
    this.reasonControl.reset();
  }
}
